import { apiClient } from "../../../base/ApiClient";

export const getEmployeesDayTimeline = async (date) => {
  const response = await apiClient.get(`/schedule/all-employees/timeline/day/`, {
    params: { date }
  });
  return response.data;
};

export const getEmployeesWeekTimeline = async (date) => {
  const response = await apiClient.get(`/schedule/all-employees/timeline/extended/`, {
    params: { 
      date, 
      view_type: 'week' 
    }
  });
  return response.data;
};

export const getEmployeesMonthTimeline = async (date) => {
  const response = await apiClient.get(`/schedule/all-employees/timeline/extended/`, {
    params: { 
      date, 
      view_type: 'month' 
    }
  });
  return response.data;
};

export const getClientDayTimeline = async (date, locationId) => {
  const params = { date };
  if (locationId) {
    params.location_id = locationId;
  }
  
  const response = await apiClient.get(`/schedule/clients/timeline/day/`, {
    params
  });
  return response.data;
};

export const getClientWeeklyTimeline = async (clientId, startDate, locationId) => {
  const params = {
    client_id: clientId,
    start_date: startDate,
  };

  if (locationId) {
    params.location_id = locationId;
  }

  const response = await apiClient.get(`/schedule/clients/timeline/week/`, {
    params
  });
  return response.data;
};